import React from "react";

import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Avatar from "@material-ui/core/Avatar";
import AvatarGroup from "@material-ui/lab/AvatarGroup";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import Subjects from "./subject_score.json";

import Logo from "../Logo/LOGO.png";

export const About = () => {
  return (
    <Container maxWidth="md">
      <section style={{ padding: "20px 0 20px 0" }}>
        <div style={{ marginBottom: "40px", textAlign: "center" }}>
          <img
            style={{ width: "200px" }}
            src={Logo}
            alt="Next Generation Democracy Logo"
          />
        </div>

        <div style={{ marginBottom: "40px" }}>
          <Typography variant="h4">Team and solution</Typography>
          <Typography>
            Citizens of Europe are disengaged from the political debate as it is
            difficult to follow the topics and themes and see a direct link to
            the politicians who shape the EU position on topics. We in the
            Danish NGO “Next Generation Democracy” wish to improve on this by
            introducing the European Politician Future Readiness Index. The
            index uses machine learning on minutes from the European Parliament,
            to link MEP’s to themes that are shaping our common future, like AI,
            Robotics or autonomous mobility. This will increase transparency and
            enable citizens to engage directly with politicians.
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "40px",
            }}
          >
            <AvatarGroup max={7}>
              <Avatar alt="Dennis" src="/static/images/avatar/1.jpg" />
              <Avatar alt="Troels" src="/static/images/avatar/2.jpg" />
              <Avatar alt="Christian" src="/static/images/avatar/3.jpg" />
              <Avatar alt="Michael" src="/static/images/avatar/4.jpg" />
              <Avatar alt="Camilla" src="/static/images/avatar/4.jpg" />
              <Avatar alt="Rasmus" src="/static/images/avatar/5.jpg" />
            </AvatarGroup>
          </div>
          <div style={{ textAlign: "center", paddingTop: "5px" }}>
            <Typography variant="caption">
              You are very welcome to reach out on{" "}
              <a
                style={{ textDecoration: "none" }}
                href="mailto:nextgenerationdemocracy@gmail.com"
              >
                nextgenerationdemocracy@gmail.com
              </a>
              .
            </Typography>
          </div>
        </div>
        <div style={{ marginBottom: "40px" }}>
          <div style={{ marginBottom: "40px" }}>
            <Typography variant="h4">Future Readiness Index</Typography>
            <Typography>
              The Future Readiness Index score each member of the European
              Parliament, based on how active they have been within one of
              several subjects that indicate “Future Readiness”. Examples are
              legislation on AI Ethics, Sustainable Energy/Industry and European
              Infrastructure. Activity is measured when a politician is a
              co-signatory in amendments to a piece of legislation that touch on
              the subjects. The subjects have been crowdsourced through a
              campaign on Twitter and is expected to be periodically updated in
              a similar manner. The index counts all activity within the current
              legislative period. National and party views show the average
              score of the politicians in the group.
            </Typography>
          </div>

          <div>
            <Typography variant="h5">Subjects in the index</Typography>
            <div>
              <Typography>
                The subjects in this list are from{" "}
                <a
                  style={{ textDecoration: "none" }}
                  href="https://oeil.secure.europarl.europa.eu/oeil/search/search.do?searchTab=y"
                >
                  source
                </a>
                .
              </Typography>
              <Table
                size="small"
                aria-label="a dense table"
                style={{ marginTop: "20px" }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Subject title</TableCell>
                    <TableCell align="right">Index score</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Subjects.sort((a, b) => {
                    if (a.score > b.score) {
                      return -1;
                    }
                    if (a.score < b.score) {
                      return 1;
                    }
                    // a must be equal to b
                    return 0;
                  }).map((subject) => (
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {subject.subj_txt}
                      </TableCell>
                      <TableCell align="right">{subject.score}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </div>
        </div>

        <div style={{ marginBottom: "40px" }}>
          <Typography variant="h4">Data processing</Typography>
          <Typography>
            The Future Readiness Index processes personal data for a
            journalistic purpose to increase the transparency of the European
            Parliament. Therefore, the General Data Protection Regulation (GDPR)
            applies to the Future Readiness Index but with exemption by
            art.17(3). As such, the GDPR does not enforce any access, objection,
            correction or removal of any personal data processed by the Future
            Readiness Index. However, if your personal data is processed by the
            Future Readiness Index, you have the right to complain, either to us
            or to your national Data Protection Authority.
          </Typography>
          <Typography>
            Reach us at{" "}
            <a
              style={{ textDecoration: "none" }}
              href="mailto:nextgenerationdemocracy@gmail.com"
            >
              nextgenerationdemocracy@gmail.com
            </a>
          </Typography>
        </div>
      </section>
    </Container>
  );
};
